import { Link } from 'react-router-dom';
import { EXTERNAL_LINKS } from '../../config/site';
import { ArrowIcon } from './Icons';

export function Eyebrow({ children, tone = 'default', className = '' }) {
  return (
    <div className={`eyebrow eyebrow--${tone} ${className}`.trim()}>
      <span className="eyebrow__dot" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}

export function ButtonLink({
  children,
  to = EXTERNAL_LINKS.app,
  variant = 'dark',
  arrow = 'right',
  className = '',
  disabled = false,
  ...rest
}) {
  const classNames = `button-link button-link--${variant} ${className}`.trim();
  const content = (
    <>
      <span className="button-link__label">{children}</span>
      <span className="button-link__icon"><ArrowIcon direction={arrow} /></span>
    </>
  );

  if (disabled) {
    return <span className={`${classNames} is-disabled`} aria-disabled="true">{content}</span>;
  }

  if (to.startsWith('/')) {
    return <Link className={classNames} to={to} {...rest}>{content}</Link>;
  }

  return <a className={classNames} href={to} {...rest}>{content}</a>;
}

export function TextLink({ children, to, arrow = 'right', className = '', ...rest }) {
  const content = <>{children}<span><ArrowIcon direction={arrow} /></span></>;
  if (to.startsWith('/')) return <Link className={`text-link ${className}`.trim()} to={to} {...rest}>{content}</Link>;
  return <a className={`text-link ${className}`.trim()} href={to} {...rest}>{content}</a>;
}

export function SectionIntro({ eyebrow, title, text, align = 'left', children, reveal = 'clip' }) {
  return (
    <div className={`section-intro section-intro--${align}`} data-reveal={reveal}>
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <h2>{title}</h2>
      {text ? <p>{text}</p> : null}
      {children}
    </div>
  );
}
